import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { ITenant, ITenants } from '@interfaces/tenants';

export interface ITenantsState extends ITenants {}

export const INITIAL_STATE: ITenantsState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class TenantsStore {
	private _tenantsState = new BehaviorSubject<ITenantsState>(INITIAL_STATE);
	readonly tenantsState$ = this._tenantsState.asObservable();

	constructor() {}

	updateTenants(tenants: ITenantsState) {
		const state = this._tenantsState.value;

		const data = {
			...state,
			...tenants,
		};

		this._tenantsState.next(data);

		return this._tenantsState.asObservable();
	}

	updateTenant(tenant: ITenant) {
		const state = this._tenantsState.value;

		const tenantIndex = state.result.findIndex(({ id }) => id === tenant.id);

		if (tenantIndex >= 0) {
			state.result[tenantIndex] = { ...state.result[tenantIndex], ...tenant };
		} else {
			state.result.push(tenant);
		}

		const data = state;

		this._tenantsState.next(data);

		return this._tenantsState.asObservable();
	}

	deleteTenant(tenant: ITenant) {
		const state = this._tenantsState.value;

		const tenantIndex = state.result.findIndex(({ id }) => id === tenant.id);

		state.result.splice(tenantIndex, 1);

		const data = state;

		this._tenantsState.next(data);

		return this._tenantsState.asObservable();
	}
}
